export default __webpack_public_path__ + "static/media/playCircle.43a058e2.png";